export const ITEM_MAINTENANCE_LISTING = 'ITEM_MAINTENANCE_LISTING';
export const ITEM_MAINTENANCE_LOADING = 'ITEM_MAINTENANCE_LOADING';
export const ITEM_MAINTENANCE_CLEAR_ITEMS_GRID =
  'ITEM_MAINTENANCE_CLEAR_ITEMS_GRID';
export const ITEM_MAINTENANCE_DELETE = 'ITEM_MAINTENANCE_DELETE';
export const ITEM_MAINTENANCE_DELETE_ERROR = 'ITEM_MAINTENANCE_DELETE_ERROR';
export const ITEM_MAINTENANCE_LISTING_ERROR = 'ITEM_MAINTENANCE_LISTING_ERROR';
export const ITEM_MAINTENANCE_CLEAR_ERRORS = 'ITEM_MAINTENANCE_CLEAR_ERRORS';
export const UPDATE_SELECTED_BID_ROW_INDEX = 'UPDATE_SELECTED_BID_ROW_INDEX';



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/state/itemMaintenance/types.js